export const shippingDetailsConstants = {
  INIT_SHIPPING_DETAILS: "INIT_SHIPPING",
  ADD_SHIPPING_ADDRESS: "ADD_SHIPPING_ADDRESS",
  UPDATE_SHIPPING_ADDRESS: "UPDATE_SHIPPING_ADDRESS"
};
